
<div>
    <div class="ms-CommandBar ms-CommandBar--navBar">
      <div class="ms-CommandBar-sideCommands">
        <div
          class="ms-CommandButton ms-CommandButton"
          [title]="formularioObj.FormularioBiblioteca ? 'Este formulario pertenece al banco de Procesos y no puede editarse. Use \'Usar proceso\' para crear una copia editable.' : ''"
        >
          <button
            class="ms-CommandButton-button"
            [class.is-biblioteca-disabled]="formularioObj.FormularioBiblioteca"
            [disabled]="formularioObj.FormularioBiblioteca"
            (click)="abrirModalEditarForm()">
            <span class="ms-CommandButton-icon ms-fontColor-themePrimary"
              ><i class="ms-Icon ms-Icon--Save"></i
            ></span>
            <span class="ms-CommandButton-label">Guardar</span>
          </button>
        </div>
      </div>

      <!-- Modal -->
      <div class="docs-DialogExample-lgHeader ">
        <div class="ms-Dialog ms-Dialog--lgHeader editar-formulario">
          <div class="ms-Dialog-title">Editar Formulario</div>
          <div class="ms-Dialog-content">
            <p class="ms-Dialog-subText">¿Seguro que desea editar el formulario?</p>
          </div>
          <div class="ms-Dialog-actions">
            <button
              class="ms-Button ms-Dialog-action ms-Button--primary"
              (click)="actualizarFormulario()"
            >
              <span class="ms-Button-label">Aceptar</span>
            </button>
            <button class="ms-Button ms-Dialog-action">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
</div>

<!-- Modal -->
<div class="docs-DialogExample-lgHeader editado">
    <div class="ms-Dialog ms-Dialog--lgHeader modal-succes">
      <div class="ms-Dialog-title">Proceso Editado Correctamente</div>
      <div class="ms-Dialog-content">
        <p class="ms-Dialog-subText">Se ha Editado el Proceso.</p>
      </div>
      <div class="ms-Dialog-actions">
        <button
          class="ms-Button ms-Dialog-action ms-Button--primary"
          (click)="abrirDatatable()"
        >
          <span class="ms-Button-label">Aceptar</span>
        </button>
      </div>
    </div>
</div>


<div id="form"></div>



<!-- <div id="formLoaded"></div> -->



